import React, { useState, useEffect } from 'react';
import { loadData } from '../services/codeDataStore';
import LegalPageLayout from '../components/LegalPageLayout';

const TermsOfService = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchTermsContent();
  }, []);

  const fetchTermsContent = async () => {
    try {
      const site = await loadData('site', {});
      if (site?.termsOfService) {
        setContent(site.termsOfService);
      } else {
        setError('Terms of Service content not found.');
      }
    } catch (err) {
      setError('Failed to fetch terms of service content.');
      console.error('Error fetching terms content:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LegalPageLayout
      title="Terms of Service"
      subtitle="Terms and conditions governing access, use, researcher conduct, and submission to the journal."
      content={content}
      loading={loading}
      error={error}
      activePolicy="terms"
    />
  );
};

export default TermsOfService;